import React from 'react';
import { picPrefixAdd } from '../../../utils';
import { Register } from '../factory';
import { ImagePicker, Modal, Toast } from 'antd-mobile';
import upload from '../../common/file-upload/upload';
import PreviewImage from '../../common/preview-Image';

@Register({ name: 'dy-file-upload' })
class DyFileUpload extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
        };
    }

    handleFileSuccess = (fileurl: string) => {
        this.props.onChange && this.props.onChange(picPrefixAdd(fileurl, ''));
    };
    handleFileError = e => {
        Toast.show(e, 3, false);
    };

    // onChange1 = () => {
    //     this.props.onChange && this.props.onChange(files)
    //     //  大小控制
    //     if (this.props.size && (files[0]?.size / 1024 / 1024 > this.props.size)) {
    //         this.props.onError && this.props.onError(`图片大小不大于${this.props.size}M!`)
    //         return
    //     }
    //     upload(files[0]).then((url:any) => {
    //         if (fileSelectorEl) {
    //             fileSelectorEl.value = '';
    //         }
    //         // 类型控制
    //         let fileType = url.split(".").pop();
    //         let isType = this.props.accept === "image/*" || this.props?.accept?.toLowerCase().indexOf(fileType.toLowerCase()) !== -1;
    //         if (!isType) {
    //             this.props.onError && this.props.onError(`图片格式仅支持：${this.props.accept} !`)
    //             return
    //         }
    //         this.props.onSuccess && this.props.onSuccess(url)
    //     }).catch(e => {
    //         this.props.onError && this.props.onError(e)
    //     })
    // }

    onChange = (files, type, index) => {
        // 已经提交过只能预览
        if (this.props.disabled) return;
        // 删除
        if (type === 'remove') {
            return this.props.onChange && this.props.onChange('');
        }
        let file = files[0]?.file;
        console.log(file, 'file');
        // 大小控制
        if (file?.size / 1024 / 1024 > 5) {
            return Toast.show('图片大小不大于5M!', 3, false);
        }
        upload(file)
            .then((url: any) => {
                console.log(url, 'urlurl');
                // 类型控制
                let fileType = url.split('.').pop();
                let isType = ['jpg', 'png', 'jpeg'].includes(fileType);
                if (!isType) {
                    return Toast.show('图片格式仅支持jpg或png格式!', 3, false);
                }
                this.props.onChange && this.props.onChange(picPrefixAdd(url, ''));
            })
            .catch(e => {
                Toast.show(e, 3, false);
            });
    };

    render() {
        let { className, name, value } = this.props;
        let { visible } = this.state;
        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                {/* <FileUpload
                    name={name}
                    className='userinfo-edit-avatar'
                    onSuccess={this.handleFileSuccess}
                    onError={this.handleFileError}
                    accept=".jpg,.png,.jpeg"
                    size={5}
                    tips="仅限jpg或png格式，不大于5M"
                >
                    <UploadPic 
                        src={picPrefixAdd(value, '')}
                        defaultPic='https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202302/23/0d2c8_20230223142409.png'
                    />
                </FileUpload> */}

                <ImagePicker
                    className="dy-fm-item-image-picker"
                    files={value ? [{ url: value }] : undefined}
                    onChange={this.onChange}
                    onImageClick={() => this.setState({ visible: true })}
                    selectable={!value}
                    accept="image/jpeg,image/jpg,image/png"
                />
                <div className="file-upload-tips">仅限jpg或png格式，不大于5M</div>

                {visible && (
                    <PreviewImage
                        visible={visible}
                        current={0}
                        urls={[value]}
                        photoClosable={true}
                        onClose={() => this.setState({ visible: false })}
                    />
                )}
            </div>
        );
    }
}

export default DyFileUpload;
